function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunningGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "350px",
    height: "350px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#08e78f",
    d: "M 178.5,116.5 C 174.297,115.127 169.963,114.46 165.5,114.5C 160.822,115.004 156.155,115.171 151.5,115C 141.877,106.66 133.711,107.827 127,118.5C 126.059,120.989 126.559,122.989 128.5,124.5C 127.669,128.476 127.503,132.476 128,136.5C 129.86,139.81 132.027,142.81 134.5,145.5C 133.905,148.14 133.572,150.807 133.5,153.5C 132.129,155.936 131.129,158.603 130.5,161.5C 130.167,162.833 129.833,164.167 129.5,165.5C 125.654,171.19 122.321,177.19 119.5,183.5C 114.669,181.343 110.502,178.343 107,174.5C 106.586,174.957 106.086,175.291 105.5,175.5C 102.482,173.474 99.4822,171.474 96.5,169.5C 96.3398,167.801 96.5065,166.134 97,164.5C 98.7498,160.359 100.416,156.359 102,152.5C 98.3939,157.045 95.8939,162.045 94.5,167.5C 90.1567,167.347 87.99,169.347 88,173.5C 90.5,176 93,178.5 95.5,181C 103.778,186.278 111.778,191.945 119.5,198C 121.365,199.301 123.365,199.635 125.5,199C 128.094,196.914 130.094,194.414 131.5,191.5C 132.167,191.5 132.833,191.5 133.5,191.5C 133.5,191.833 133.5,192.167 133.5,192.5C 135.254,198.97 137.254,205.303 139.5,211.5C 130.525,227.444 121.025,243.11 111,258.5C 106.12,280.791 101.786,303.125 98,325.5C 99.6667,326.833 101.333,326.833 103,325.5C 108.41,309.767 113.91,294.101 119.5,278.5C 121.888,277.781 123.388,276.115 124,273.5C 125.31,269.93 126.143,266.263 126.5,262.5C 134.79,252.373 143.29,242.373 152,232.5C 152.906,248.625 154.573,264.625 157,280.5C 157.75,281.126 158.584,281.626 159.5,282C 165.827,282.651 172.16,283.151 178.5,283.5C 178.667,300.17 178.5,316.837 178,333.5C 177.08,338.188 174.58,341.688 170.5,344C 138.559,353.322 106.059,359.822 73,363.5C 61.4746,364.914 53.808,360.247 50,349.5C 49.3333,253.833 49.3333,158.167 50,62.5C 52.1896,47.3114 60.6896,42.1447 75.5,47C 107.059,56.7215 138.393,67.0548 169.5,78C 174.043,82.5851 176.876,88.0851 178,94.5C 178.5,101.826 178.666,109.159 178.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#000201",
    d: "M 178.5,116.5 C 188.123,119.282 192.289,125.616 191,135.5C 187.743,139.856 183.577,141.523 178.5,140.5C 172.259,136.826 167.592,138.326 164.5,145C 157.491,148.879 151.158,148.046 145.5,142.5C 141.68,137.549 139.513,131.883 139,125.5C 138.085,124.672 137.419,123.672 137,122.5C 136.517,123.448 136.351,124.448 136.5,125.5C 133.794,125.425 131.127,125.092 128.5,124.5C 126.559,122.989 126.059,120.989 127,118.5C 133.711,107.827 141.877,106.66 151.5,115C 156.155,115.171 160.822,115.004 165.5,114.5C 169.963,114.46 174.297,115.127 178.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838ceb",
    d: "M 145.5,142.5 C 141.489,146.751 137.656,151.418 134,156.5C 133.517,155.552 133.351,154.552 133.5,153.5C 133.572,150.807 133.905,148.14 134.5,145.5C 132.027,142.81 129.86,139.81 128,136.5C 127.503,132.476 127.669,128.476 128.5,124.5C 131.127,125.092 133.794,125.425 136.5,125.5C 136.351,124.448 136.517,123.448 137,122.5C 137.419,123.672 138.085,124.672 139,125.5C 139.513,131.883 141.68,137.549 145.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#13e48e",
    d: "M 178.5,140.5 C 178.5,145.833 178.5,151.167 178.5,156.5C 177.833,156.5 177.167,156.5 176.5,156.5C 168.873,152.847 160.873,150.18 152.5,148.5C 151.833,148.167 151.167,147.833 150.5,147.5C 147.63,146.922 145.963,145.255 145.5,142.5C 151.158,148.046 157.491,148.879 164.5,145C 167.592,138.326 172.259,136.826 178.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f9fa",
    d: "M 145.5,142.5 C 145.963,145.255 147.63,146.922 150.5,147.5C 154.423,152.945 156.757,158.945 157.5,165.5C 158.517,169.053 160.017,172.386 162,175.5C 166.333,179.5 170.667,183.5 175,187.5C 175.667,189.167 175.667,190.833 175,192.5C 172.328,193.282 169.828,194.282 167.5,195.5C 165.407,196.045 163.407,196.878 161.5,198C 155.779,202.721 149.779,207.054 143.5,211C 142.207,211.49 140.873,211.657 139.5,211.5C 137.254,205.303 135.254,198.97 133.5,192.5C 135.416,191.335 136.249,189.668 136,187.5C 134.905,188.693 134.072,190.027 133.5,191.5C 132.833,191.5 132.167,191.5 131.5,191.5C 125.741,191.299 121.741,188.632 119.5,183.5C 122.321,177.19 125.654,171.19 129.5,165.5C 131.054,164.086 132.388,162.419 133.5,160.5C 133.333,160.167 133.167,159.833 133,159.5C 132.292,160.381 131.458,161.047 130.5,161.5C 131.129,158.603 132.129,155.936 133.5,153.5C 133.351,154.552 133.517,155.552 134,156.5C 137.656,151.418 141.489,146.751 145.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafdfc",
    d: "M 152.5,148.5 C 160.873,150.18 168.873,152.847 176.5,156.5C 176.348,160.924 175.681,165.257 174.5,169.5C 173.735,169.923 172.902,170.257 172,170.5C 167.361,169.121 162.861,167.455 158.5,165.5C 158.47,159.113 156.47,153.446 152.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#484a49",
    d: "M 150.5,147.5 C 151.167,147.833 151.833,148.167 152.5,148.5C 156.47,153.446 158.47,159.113 158.5,165.5C 158.167,165.5 157.833,165.5 157.5,165.5C 156.757,158.945 154.423,152.945 150.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#8991f6",
    d: "M 176.5,156.5 C 177.167,156.5 177.833,156.5 178.5,156.5C 181.233,156.948 183.399,158.281 185,160.5C 186.406,177.181 187.572,193.848 188.5,210.5C 187.737,211.719 186.737,212.719 185.5,213.5C 187.167,215.167 186.833,216.167 184.5,216.5C 182.199,216.016 180.199,215.016 178.5,213.5C 177.898,198.63 176.565,183.963 174.5,169.5C 175.681,165.257 176.348,160.924 176.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#98f3d0",
    d: "M 96.5,169.5 C 95.5,169.167 94.8333,168.5 94.5,167.5C 95.8939,162.045 98.3939,157.045 102,152.5C 100.416,156.359 98.7498,160.359 97,164.5C 96.5065,166.134 96.3398,167.801 96.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#363737",
    d: "M 129.5,165.5 C 129.833,164.167 130.167,162.833 130.5,161.5C 131.458,161.047 132.292,160.381 133,159.5C 133.167,159.833 133.333,160.167 133.5,160.5C 132.388,162.419 131.054,164.086 129.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8893f5",
    d: "M 94.5,167.5 C 94.8333,168.5 95.5,169.167 96.5,169.5C 99.4822,171.474 102.482,173.474 105.5,175.5C 106.086,175.291 106.586,174.957 107,174.5C 110.502,178.343 114.669,181.343 119.5,183.5C 121.741,188.632 125.741,191.299 131.5,191.5C 130.094,194.414 128.094,196.914 125.5,199C 123.365,199.635 121.365,199.301 119.5,198C 111.778,191.945 103.778,186.278 95.5,181C 93,178.5 90.5,176 88,173.5C 87.99,169.347 90.1567,167.347 94.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c7fae5",
    d: "M 75.5,153.5 C 76.1239,153.917 76.4573,154.584 76.5,155.5C 74.0414,166.516 73.8748,177.516 76,188.5C 74.883,187.051 74.2163,185.384 74,183.5C 73.0799,173.407 73.5799,163.407 75.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b3b3b",
    d: "M 142.5,172.5 C 143.239,172.369 143.906,172.536 144.5,173C 141.821,179.105 141.154,178.939 142.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#555555",
    d: "M 156.5,187.5 C 157.562,185.243 159.228,184.077 161.5,184C 160.211,185.802 158.544,186.969 156.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#363636",
    d: "M 133.5,192.5 C 133.5,192.167 133.5,191.833 133.5,191.5C 134.072,190.027 134.905,188.693 136,187.5C 136.249,189.668 135.416,191.335 133.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#434343",
    d: "M 156.5,187.5 C 151.145,193.349 145.812,198.849 140.5,204C 144.687,197.314 150.02,191.814 156.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.967
    },
    fill: "#12e592",
    d: "M 157.5,165.5 C 157.833,165.5 158.167,165.5 158.5,165.5C 162.861,167.455 167.361,169.121 172,170.5C 172.902,170.257 173.735,169.923 174.5,169.5C 176.565,183.963 177.898,198.63 178.5,213.5C 178.5,232.5 178.5,251.5 178.5,270.5C 175.748,270.762 172.748,270.762 169.5,270.5C 169.667,253.83 169.5,237.163 169,220.5C 168.184,221.823 167.017,222.489 165.5,222.5C 166.976,220.5 168.809,218.833 171,217.5C 173,212.167 173,206.833 171,201.5C 169.558,199.609 168.391,197.609 167.5,195.5C 169.828,194.282 172.328,193.282 175,192.5C 175.667,190.833 175.667,189.167 175,187.5C 170.667,183.5 166.333,179.5 162,175.5C 160.017,172.386 158.517,169.053 157.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#605fc6",
    d: "M 167.5,195.5 C 168.391,197.609 169.558,199.609 171,201.5C 173,206.833 173,212.167 171,217.5C 168.809,218.833 166.976,220.5 165.5,222.5C 167.017,222.489 168.184,221.823 169,220.5C 169.5,237.163 169.667,253.83 169.5,270.5C 172.748,270.762 175.748,270.762 178.5,270.5C 192.077,273.152 205.744,275.485 219.5,277.5C 218.735,280.096 218.401,282.763 218.5,285.5C 205.18,284.738 191.847,284.072 178.5,283.5C 172.16,283.151 165.827,282.651 159.5,282C 158.584,281.626 157.75,281.126 157,280.5C 154.573,264.625 152.906,248.625 152,232.5C 143.29,242.373 134.79,252.373 126.5,262.5C 125.21,263.058 124.377,264.058 124,265.5C 122.486,269.854 120.986,274.188 119.5,278.5C 113.91,294.101 108.41,309.767 103,325.5C 101.333,326.833 99.6667,326.833 98,325.5C 101.786,303.125 106.12,280.791 111,258.5C 121.025,243.11 130.525,227.444 139.5,211.5C 140.873,211.657 142.207,211.49 143.5,211C 149.779,207.054 155.779,202.721 161.5,198C 163.407,196.878 165.407,196.045 167.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#26c49d",
    d: "M 165.5,222.5 C 164.415,224.587 162.749,225.92 160.5,226.5C 161.585,224.413 163.251,223.08 165.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#24c39e",
    d: "M 160.5,226.5 C 159.438,228.757 157.772,229.923 155.5,230C 156.789,228.198 158.456,227.031 160.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#94f5cc",
    d: "M 92.5,183.5 C 93.6541,196.678 95.6541,209.845 98.5,223C 97.8946,229.591 96.7279,236.091 95,242.5C 94.2181,256.247 94.5514,269.914 96,283.5C 93.6872,274.998 92.5205,266.331 92.5,257.5C 93.0662,245.505 94.7328,233.671 97.5,222C 93.8253,209.443 92.1587,196.609 92.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7f8de",
    d: "M 113.5,243.5 C 114.043,243.56 114.376,243.893 114.5,244.5C 112.714,248.307 111.548,252.307 111,256.5C 110.405,251.883 111.238,247.549 113.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bdf9e1",
    d: "M 140.5,251.5 C 141.087,259.212 139.92,266.879 137,274.5C 138.099,266.836 139.266,259.169 140.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71e2b8",
    d: "M 126.5,262.5 C 126.143,266.263 125.31,269.93 124,273.5C 123.388,276.115 121.888,277.781 119.5,278.5C 120.986,274.188 122.486,269.854 124,265.5C 124.377,264.058 125.21,263.058 126.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbf9df",
    d: "M 77.5,246.5 C 78.0967,246.735 78.4301,247.235 78.5,248C 77.4687,253.614 76.802,259.281 76.5,265C 77.1742,270.859 77.6742,276.692 78,282.5C 74.8346,270.512 74.668,258.512 77.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.822
    },
    fill: "#000001",
    d: "M 219.5,277.5 C 221.484,277.383 223.15,278.05 224.5,279.5C 226.564,284.026 228.231,288.692 229.5,293.5C 228.635,294.583 227.635,294.749 226.5,294C 223.601,291.271 220.934,288.438 218.5,285.5C 218.401,282.763 218.735,280.096 219.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3f9e4",
    d: "M 126.5,288.5 C 128.379,288.393 128.712,288.893 127.5,290C 125.635,291.301 123.635,291.635 121.5,291C 123.491,290.626 125.158,289.793 126.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2f6d4",
    d: "M 130.5,300.5 C 131.239,300.369 131.906,300.536 132.5,301C 128.945,304.134 124.945,305.301 120.5,304.5C 124.271,304.003 127.604,302.67 130.5,300.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningGirl);
export default __webpack_public_path__ + "static/media/running-girl.bd0cc130f398f08ba9781c6b3a1ddf52.svg";
export { ForwardRef as ReactComponent };